import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const UserContextPanel = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { user, userProfile } = useAuth();

  const displayName = user?.user_metadata?.full_name || user?.email || 'User';
  const role = user?.user_metadata?.role || userProfile?.role || 'guest';
  const initials = displayName?.split(' ')?.slice(0, 2)?.map(n => n?.[0]?.toUpperCase())?.join('') || 'U';

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(e?.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const roleColors = { admin: '#B8963E', viewer: '#4A7FD4', guest: '#1A7A4A' };
  const roleColor = roleColors?.[role] || '#6B6B80';

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 p-1 rounded-xl border border-border bg-card hover:bg-muted transition-colors"
      >
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
          style={{ background: `linear-gradient(135deg, ${roleColor} 0%, ${roleColor}cc 100%)` }}
        >
          {initials}
        </div>
        <div className="hidden md:block text-left pr-1">
          <div className="text-xs font-semibold text-foreground leading-tight max-w-[100px] truncate">{displayName?.split(' ')?.[0]}</div>
          <div className="text-xs text-muted-foreground capitalize">{role}</div>
        </div>
        <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={14} className="text-muted-foreground hidden md:block mr-1" />
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-64 bg-popover border border-border rounded-xl shadow-xl z-50 overflow-hidden">
          <div className="p-4 border-b border-border">
            <div className="flex items-center gap-3">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
                style={{ background: `linear-gradient(135deg, ${roleColor} 0%, ${roleColor}cc 100%)` }}
              >
                {initials}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-foreground truncate">{displayName}</p>
                <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
              </div>
            </div>
            <div className="mt-3 flex items-center gap-2 px-2.5 py-1.5 bg-muted rounded-lg">
              <div className="w-2 h-2 rounded-full" style={{ background: roleColor }} />
              <span className="text-xs font-semibold capitalize" style={{ color: roleColor }}>{role} Access</span>
            </div>
          </div>

          <div className="p-1.5">
            <button className="w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors hover:bg-muted text-left">
              <Icon name="Settings" size={16} className="text-muted-foreground" />
              <span className="text-sm text-foreground">Settings</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserContextPanel;